export const FOCUSABLE_ELEMENTS_STRING = [
  'a[href]',
  'area[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'details',
  'summary',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
].join(',');

export const KEYCODES = {
  ESC: 'Escape',
};
